import { supabase } from "@/integrations/supabase/client";

export class GoogleDriveService {
  static readonly scope = "https://www.googleapis.com/auth/drive.file";

  static getOAuthUrl(): string {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
    if (!clientId) {
      throw new Error("VITE_GOOGLE_CLIENT_ID is not configured");
    }

    const redirectUri = encodeURIComponent(
      `${window.location.origin}/genie-hub/connections/google-drive/callback`,
    );
    const scopes = encodeURIComponent(this.scope);
    const state = Math.random().toString(36).substring(7);

    return `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&access_type=offline&state=${state}`;
  }

  static async getConnectionStatus() {
    const { data, error } = await supabase.functions.invoke("cloud-storage", {
      body: {
        action: "get-status",
        data: { provider: "google_drive" },
      },
    });

    if (error) {
      throw new Error(error.message || "Failed to get connection status");
    }

    return data;
  }

  static async disconnect() {
    const { data, error } = await supabase.functions.invoke("cloud-storage", {
      body: {
        action: "revoke",
        data: { provider: "google_drive" },
      },
    });

    if (error) {
      throw new Error(error.message || "Failed to disconnect");
    }

    return data;
  }
}
